module.exports = __webpack_public_path__ + "img/logo.2d9eafde.png";